import { connect } from 'react-redux';
import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IBuilderSuggest } from '../../types/builder';
import { filterRoads } from '../../store/roads/filterRoads';
import { selectRoads } from '../../store/roads/selectRoads';
import { removeSavedFilter } from '../../store/saved_filters/removeSavedFilter';
import { filterStations } from '../../store/stations/filterStations';
import { selectStations } from '../../store/stations/selectStations';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';
import { IRailway, IRoad } from '../../types/geo';
import { Filters } from '.';
import { IRange } from '../../interfaces/filters';
import { showCommutePopup } from '../../store/commute_popup/actions';
import {
  changeFinishDateFilter,
  changeNewObjectTypeFilter,
  changePage,
  changePriceRangeFilter,
  changeQueryString,
  changeRegion,
  changeVillageClassFilter,
} from '../../store/filters/actions';
import { ICity, IGeo } from '../../store/geo';
import { geoPopupClosed, geoPopupOpened } from '../../store/geo/actions';
import {
  clearBuilderSuggestions,
  clearVillageSuggestions,
  fetchBuilderSuggestions,
  fetchCachedGeocode,
  fetchRegions,
  fetchRegionsCities,
  fetchVillageSuggestions,
} from '../../store/geo/thunkActions';
import { IRoads } from '../../store/roads';
import { ISavedFilters } from '../../store/saved_filters';
import { addSavedFilter, ISavedFilter } from '../../store/saved_filters/actions';
import { IStations } from '../../store/stations';
import { selectBuilder } from '../../store/stations/actions';
import { clearVillageList } from '../../store/village_list/actions';

export interface IFiltersStoreProps {
  commutePopupOpened?: boolean;
  filters: IGetVillageListRequestSchema;
  geo: IGeo;
  roads: IRoads;
  savedFilters: ISavedFilters;
  stations: IStations;
  roadData?: IGetVillageListResponseSchema['roadData'];
  stationData?: IGetVillageListResponseSchema['stationData'];
}

export function mapStateToProps(state: IApplicationState): IFiltersStoreProps {
  return {
    commutePopupOpened: state.commutePopup.opened,
    filters: state.filters,
    geo: state.geo,
    roadData: state.villageList ? state.villageList.roadData : undefined,
    roads: state.roads,
    savedFilters: state.savedFilters,
    stationData: state.villageList ? state.villageList.stationData : undefined,
    stations: state.stations,
  };
}

export interface IFiltersDispatchProps {
  addSavedFilter(value: ISavedFilter): void;
  openGeoPopup(): void;
  closeGeoPopup(): void;
  changeNewObjectTypeFilter(value: string[]): void;
  changeVillageClassFilter(value: string[]): void;
  changeFinishDateFilter(value: string): void;
  changePriceRangeFilter(range: IRange): void;
  changeQueryString(filters: IGetVillageListRequestSchema): void;
  changeRegion(region: ICity): void;
  clearVillageList(filters: IGetVillageListRequestSchema): void;
  clearVillageSuggestions(): void;
  clearBuilderSuggestions(): void;
  fetchCachedGeocode(request: string): void;
  fetchRegions(): void;
  fetchRegionsCities(text: string): void;
  fetchVillageSuggestions(text: string): void;
  fetchBuilderSuggestions(text: string): void;
  filterRoads(text: string): void;
  filterStations(text: string): void;
  removeSavedFilter(value: ISavedFilter): void;
  refreshPage(curPage: number, shouldNotLoadData?: boolean): void;
  refreshRegions(region: ICity, loadNeeded?: boolean): void;
  selectRoad(road: IRoad): void;
  selectStation(station: IRailway): void;
  selectBuilder(builder: IBuilderSuggest): void;
  showCommutePopup(): void;
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IFiltersDispatchProps {
  return {
    addSavedFilter: value => dispatch(addSavedFilter(value)),
    openGeoPopup: () => dispatch(geoPopupOpened()),
    closeGeoPopup: () => dispatch(geoPopupClosed()),
    changeFinishDateFilter: value => dispatch(changeFinishDateFilter(value)),
    changeNewObjectTypeFilter: (value: string[]) => dispatch(changeNewObjectTypeFilter({ value })),
    changePriceRangeFilter: range => dispatch(changePriceRangeFilter(range)),
    changeQueryString: filters => dispatch(changeQueryString(filters)),
    changeRegion: city => dispatch(changeRegion(city, true)),
    changeVillageClassFilter: (value: string[]) => dispatch(changeVillageClassFilter({ value })),
    clearVillageList: value => dispatch(clearVillageList(value)),
    clearVillageSuggestions: () => dispatch(clearVillageSuggestions()),
    clearBuilderSuggestions: () => dispatch(clearBuilderSuggestions()),
    fetchCachedGeocode: request => dispatch(fetchCachedGeocode({ request })),
    fetchRegions: () => dispatch(fetchRegions()),
    fetchRegionsCities: text => dispatch(fetchRegionsCities(text)),
    fetchVillageSuggestions: text => dispatch(fetchVillageSuggestions(text)),
    fetchBuilderSuggestions: text => dispatch(fetchBuilderSuggestions(text)),
    filterRoads: text => dispatch(filterRoads(text)),
    filterStations: text => dispatch(filterStations(text)),
    refreshPage: (curPage, shouldNotLoadData) => dispatch(changePage(curPage, shouldNotLoadData)),
    refreshRegions: (city, loadNeeded) => dispatch(changeRegion(city, false, loadNeeded)),
    removeSavedFilter: value => dispatch(removeSavedFilter(value)),
    selectRoad: value => dispatch(selectRoads([value])),
    selectStation: value => dispatch(selectStations([value])),
    selectBuilder: value => dispatch(selectBuilder(value)),
    showCommutePopup: () => dispatch(showCommutePopup()),
  };
}

export const FiltersContainer = connect<IFiltersStoreProps, IFiltersDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Filters);
